export default __webpack_public_path__ + "static/media/colourful.c08ce0c3.jpg";